module.exports = __webpack_public_path__ + "img/User-Visibility-Restrictions.ef71998b.svg";